//src/components/configuration/ph5/message/Menu.js
//an opened message menu item

import React from 'react';
import { Grid, Button, ButtonGroup, TextField } from '@material-ui/core';
import SelectIcon from '@material-ui/icons/CheckCircleOutline';
import TrashIcon from '@material-ui/icons/Delete';
import Display from '../../display/Display';



export default function MessageMenu(props){
    const {message, width, height, onSelect, onDelete, render, onSave, splitVertical} = props;
    const [confirmed, setConfirmed] = React.useState(false);
    const [name, setName] = React.useState(message.name);
    const [description, setDescription] = React.useState(message.description);

    const showSave = !(name === message.name && description === message.description);
    //const [changed, setChanged] = React.useState(false);

    const handleClickDelete = (e) => {
        if(confirmed) return onDelete(message);
        setConfirmed(true);
    }

    const renderDeleteLabel = () => {
        if(message.total > 0) return [message.total, 'Use'+(message.total > 1 ? 's' : '')].join(' ');
        if(confirmed) return 'Really delete?';
        return 'Delete';
    }

    const handleChangeName = (e) => {
        setName(e.target.value);
    }

    const handleChangeDescription = (e) => {
        setDescription(e.target.value);
    }

    const handleSave = (e) => {
        //console.log("saving name", name, 'description', description);
        onSave(Object.assign({}, message, {
            name: name,
            description: description
        }));
    }
    //TODO: add name & description text fields with save button
    return (
        <Grid container style={{maxWidth: Math.ceil(220 / width)*width+20 }}>
            <Grid item xs={12}>
                <ButtonGroup fullWidth>
                    <Button variant="contained" color="primary"
                        startIcon={<SelectIcon />}
                        onClick={onSelect}>Select</Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<TrashIcon />}
                        onClick={handleClickDelete}
                        disabled={message.total > 0 ? true : false}
                    >{renderDeleteLabel()}</Button>
                </ButtonGroup>
            </Grid>
            <Grid item xs={12}>
                <Display
                    pixel_map={render(message)}
                    width={width}
                    height={height}
                    splitVertical={splitVertical}
                    scale={Math.ceil(220 / width)}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="msg_name"
                    name="name"
                    label="Name"
                    value={name}
                    onChange={handleChangeName}
                    fullWidth
                />
                <TextField
                    id="msg_description"
                    name="description"
                    label="Description"
                    value={description}
                    onChange={handleChangeDescription}
                    fullWidth
                />
                {showSave ? (<Button variant="contained" color="primary" onClick={handleSave} fullWidth>Save</Button>) : ''}
            </Grid>
        </Grid>
    );
}